import { InputBaseType } from '@/components/ReportForm/InputBase/types';
import { useTranslation } from '@/i18n';
import {
  FormInput,
  FormInputProps,
} from '@moneyforward/ap-frontend-components';
import { memo, useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { PAYEE_FORM_MAX_LENGTH } from '../constants';

export type Props<TFieldValues extends FieldValues> = Omit<
  InputBaseType<TFieldValues>,
  'label' | 'tooltip' | 'caption' | 'hidden'
> &
  FormInputProps<TFieldValues> & {
    maxLength?: number;
  };

const InnerApPayeeFormInputContactPhoneNumber = <
  TFieldValues extends FieldValues
>({
  control,
  name,
  inputId,
  required = false,
  maxLength = PAYEE_FORM_MAX_LENGTH.CONTACT_PHONE_NUMBER,
  ...rest
}: Props<TFieldValues>) => {
  const { t } = useTranslation();

  const rules = useMemo(
    () => ({
      required: required ? t('required') : false,
      maxLength: {
        value: maxLength,
        message: t('ap_payee_contact_person_phone_number_max_error', {
          maxLength: maxLength,
        }),
      },
    }),
    [required, t, maxLength]
  );

  return (
    <FormInput<TFieldValues>
      control={control}
      name={name}
      inputId={inputId}
      rules={rules}
      {...rest}
    />
  );
};

InnerApPayeeFormInputContactPhoneNumber.displayName =
  'InnerApPayeeFormInputContactPhoneNumber';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const ApPayeeFormInputContactPhoneNumber = memo((props) => (
  <InnerApPayeeFormInputContactPhoneNumber {...props} />
)) as typeof InnerApPayeeFormInputContactPhoneNumber;
ApPayeeFormInputContactPhoneNumber.displayName =
  'ApPayeeFormInputContactPhoneNumber';
